import LandingLayout from "components/common/landingLayout";
import Gecco from "components/gecco";
import React from "react";

const GeccoPage = () => {
  return (
    <LandingLayout>
      <Gecco />
    </LandingLayout>
  );
};

export default GeccoPage;
